<template>
  <div>
    <slot :product="product" />
  </div>
</template>

<script>
import productQuery from "@/graphql/queries/Product.gql";

export default {
  name: "ProductByHandleQueryWrapper",
  props: {
    handle: {
      type: String,
      required: true,
    },
  },
  apollo: {
    product: {
      query: productQuery,
      variables() {
        return {
          product: this.handle,
          selectedOptions: [],
        };
      },
    },
  },
};
</script>
